export const environment = {     production: true,     apiURL: 'https://rms.hopetrust.co.ke',     apiVersion: 'api',     fileServerURL: 'https://rms.hopetrust.co.ke/fileserver',     instanceName: 'HOPETRUST'     };
